(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-stk-reveal]:not(.is-in),[data-stk-plates]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    // Starts a little before the element reaches the screen, so a fast scroll on a phone doesn't land on empty space.
    // Anything already above the screen (a jump link, a restored scroll position) is shown straight away.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting || en.boundingClientRect.bottom < 0) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px 15% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // At 990px and up Horizon scrolls .page-wrapper instead of the window, so window.scrollY stays 0 there.
  function scrollTop() {
    var pw = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
  }

  function initHero(root) {
    (root || document).querySelectorAll('[data-stk-stage]').forEach(function (stage) {
      if (stage.__stk) return; stage.__stk = true;
      var follow = stage.getAttribute('data-follow') !== 'false' && !touch;
      var tx = 0, ty = 0, cx = 0, cy = 0, t0 = performance.now();
      var scale = 1, seen = true, running = false, last = '';
      function measure() { scale = Math.max(0.3, Math.min(1, stage.offsetWidth / 1180)); }
      measure();
      if (reduce) { stage.style.setProperty('--dx', 5 * scale); stage.style.setProperty('--dy', 3.4 * scale); return; }
      // The loop only runs while the hero is on screen and something still moves: the intro, the cursor easing in, or a scroll.
      function frame(now) {
        running = false;
        if (!stage.isConnected || !seen) return;
        var k = Math.min(1, Math.max(0, (now - t0 - 300) / 1600));
        var amp = (1 - Math.pow(1 - k, 4)) * scale;
        cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
        var sy = 1 + Math.min(1, scrollTop() / 600) * (touch ? 0.35 : 0.6);
        var dx = (amp * (5 - cx * 4) * sy).toFixed(3), dy = (amp * (3.4 - cy * 3.4) * sy).toFixed(3);
        if (dx + '/' + dy !== last) { last = dx + '/' + dy; stage.style.setProperty('--dx', dx); stage.style.setProperty('--dy', dy); }
        if (k < 1 || Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) wake();
      }
      function wake() { if (running || !seen) return; running = true; requestAnimationFrame(frame); }
      window.addEventListener('resize', function () { measure(); wake(); }, { passive: true });
      window.addEventListener('pointermove', function (e) {
        if (!follow) return;
        tx = (e.clientX / innerWidth - 0.5) * 2; ty = (e.clientY / innerHeight - 0.5) * 2;
        wake();
      }, { passive: true });
      // Captured at the document so it also hears .page-wrapper, whose scroll events don't bubble.
      document.addEventListener('scroll', wake, { passive: true, capture: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { seen = entries[0].isIntersecting; wake(); }).observe(stage);
      }
      wake();
    });
  }

  function fallbackAdd(id) {
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (res) { if (res.status) throw new Error(res.message); window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart'; });
  }

  function initQuickAdd(root) {
    (root || document).querySelectorAll('[data-stk-add]').forEach(function (btn) {
      if (btn.__stk) return; btn.__stk = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (btn.disabled) return;
        var icon = btn.hasAttribute('data-stk-icon');
        var label = icon ? btn.getAttribute('aria-label') : btn.textContent;
        // Icon-only buttons show state with classes and announce it through aria-label; text buttons swap their text.
        function state(name, text) {
          if (!icon) { btn.textContent = text; return; }
          btn.classList.remove('is-busy', 'is-done', 'is-error');
          if (name) btn.classList.add('is-' + name);
          btn.setAttribute('aria-label', text);
        }
        var id = Number(btn.getAttribute('data-stk-add'));
        btn.disabled = true; state('busy', 'Adding…');
        var actions = window.Shopify && Shopify.actions;
        var job = actions && actions.updateCart
          ? actions.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }] }, { context: 'product' }).then(function (res) {
              if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
              state('done', 'Added to cart');
              if (actions.openCart) actions.openCart();
            })
          : fallbackAdd(id);
        Promise.resolve(job).catch(function (err) { console.warn('[stak] quick add', err); state('error', 'Could not add, try again'); })
          .finally(function () { setTimeout(function () { btn.disabled = false; state('', label); }, 1400); });
      });
    });
  }

  // Mobile collections carousel: one tile per view, swipe or use the arrows; the counter follows the scroll.
  function initSlider(root) {
    (root || document).querySelectorAll('[data-stk-slider]').forEach(function (box) {
      if (box.__stk) return; box.__stk = true;
      var track = box.querySelector('[data-stk-track]'), prev = box.querySelector('[data-stk-prev]'), next = box.querySelector('[data-stk-next]'), count = box.querySelector('[data-stk-count]');
      if (!track || !prev || !next) return;
      var tiles = track.children, total = tiles.length, pad = function (n) { return (n < 10 ? '0' : '') + n; };
      function index() { var step = tiles.length > 1 ? tiles[1].offsetLeft - tiles[0].offsetLeft : track.clientWidth; return Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / (step || 1)))); }
      function update() { var i = index(); prev.disabled = i === 0; next.disabled = i === total - 1; if (count) count.textContent = pad(i + 1) + ' / ' + pad(total); }
      function go(d) { var t = tiles[index() + d]; if (t) track.scrollTo({ left: t.offsetLeft - tiles[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      var ticking = false;
      track.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }, { passive: true });
      update();
    });
  }

  // In-page links such as the hero's "Collections" button scroll smoothly instead of jumping.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-stk-jump]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });

  // On phones the floating WhatsApp button slides away while the page scrolls down, so it doesn't sit on the text being read.
  // It comes back when scrolling up, near the top, and at the end of the page.
  (function () {
    var phone = window.matchMedia('(max-width: 749px)'), last = window.scrollY, ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY, dy = y - last, away = null;
      if (!phone.matches || y < 120 || y + innerHeight >= document.documentElement.scrollHeight - 80) away = false;
      else if (dy > 8) away = true;
      else if (dy < -8) away = false;
      if (Math.abs(dy) > 8 || away === false) last = y;
      if (away === null) return;
      document.querySelectorAll('.stk-wa').forEach(function (b) { b.classList.toggle('is-away', away); });
    }
    window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(update); }, { passive: true });
  })();

  // The floating WhatsApp button steps aside while it would sit on top of a small control: the hero's "Collections"
  // button on a 1280×800 laptop, a card's quick add, the pagination "Next" link, and so on. It comes back once that
  // control scrolls away. Big link areas (a whole product card or collection tile) don't count; they stay clickable around it.
  // The resting spot is read from CSS rather than the button's box, so the slide-away transform doesn't make it flicker.
  (function () {
    var ticking = false, CONTROL = 'a,button,input,select,textarea,summary,label,[role="button"]';
    function spot(b) {
      var cs = getComputedStyle(b), right = innerWidth - parseFloat(cs.right), bottom = innerHeight - parseFloat(cs.bottom);
      // 12px extra on the top-left covers the stacked green shadow.
      return { left: right - b.offsetWidth - 12, right: right, top: bottom - b.offsetHeight - 12, bottom: bottom };
    }
    function coversControl(s) {
      for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) {
        var x = s.left + (s.right - s.left) * (i + 0.5) / 3, y = s.top + (s.bottom - s.top) * (j + 0.5) / 3;
        // Skips the button itself, and iframes laid over the page (Shopify's preview bar) so the check sees the page underneath.
        var under = document.elementsFromPoint(x, y).filter(function (el) {
          return !el.closest('.stk-wa') && el.tagName !== 'IFRAME' && !el.querySelector(':scope > iframe');
        })[0];
        var ctl = under && under.closest(CONTROL);
        if (ctl) { var r = ctl.getBoundingClientRect(); if (r.width <= 420 && r.height <= 160) return true; }
      }
      return false;
    }
    function update() {
      ticking = false;
      document.querySelectorAll('.stk-wa').forEach(function (b) { b.classList.toggle('is-tucked', coversControl(spot(b))); });
    }
    function queue() { if (ticking) return; ticking = true; requestAnimationFrame(update); }
    // Capture, because on desktop Horizon scrolls the page inside a container rather than the window.
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue, { passive: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue); else queue();
  })();

  // Product cards flip through their photos while the mouse is over them. Each photo comes into focus over the last
  // (stak.css), and moving the mouse across the photo picks the photo under that part of the ticks; autoplay then
  // carries on from there. A short hover-intent delay keeps a mouse sweeping across the grid from starting cards or
  // downloading their photos, which only load on the first real hover. Touch screens never start it; with reduced motion
  // the card just shows its second photo and the mouse can still pick others. Delegated on document, so cards re-rendered
  // by filters or pagination work without re-init.
  (function () {
    var INTENT = 120, FIRST = 380, STEP = 1600, LEAVE = 260, PATIENCE = 1500;
    function ready(img) { return img.complete && img.naturalWidth > 0; }
    function broken(img) { return img.complete && img.naturalWidth === 0 && img.hasAttribute('src'); }
    // The next photo to show: broken ones are skipped, and one still downloading is waited for up to PATIENCE before
    // it's skipped too, so a slow or missing photo can't freeze the cycle. -1 means keep waiting.
    function pick(st) {
      for (var k = 1; k < st.frames.length; k++) {
        var n = (st.i + k) % st.frames.length, img = st.frames[n];
        if (ready(img)) { st.since = 0; return n; }
        if (broken(img)) continue;
        if (!st.since) st.since = Date.now();
        if (Date.now() - st.since < PATIENCE) return -1;
      }
      return -1;
    }
    function load(st) {
      st.frames.forEach(function (img) {
        if (!img.hasAttribute('data-srcset')) return;
        img.srcset = img.getAttribute('data-srcset'); img.src = img.getAttribute('data-src');
        img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
      });
    }
    function ticks(st, n, ms) {
      st.ticks.forEach(function (t, k) { t.classList.remove('is-on'); t.classList.toggle('is-done', k < n || (k === n && !ms)); });
      var t = st.ticks[n];
      if (t && ms) { t.style.setProperty('--stk-tick', ms + 'ms'); void t.offsetWidth; t.classList.add('is-on'); }
    }
    // Brings photo n in over the current one, which stays underneath until the transition ends. False while n is loading.
    function show(st, n, ms) {
      if (n === st.i) return true;
      if (!ready(st.frames[n])) return false;
      st.frames.forEach(function (img, k) { img.classList.toggle('is-on', k === n); img.classList.toggle('is-prev', k === st.i); });
      st.i = n; ticks(st, n, ms);
      return true;
    }
    function play(st, ms) {
      clearTimeout(st.t);
      st.t = setTimeout(function next() {
        var n = pick(st);
        if (n < 0) { st.t = setTimeout(next, 100); return; }
        show(st, n, STEP); st.t = setTimeout(next, STEP);
      }, ms);
    }
    function begin(card, st) {
      st.on = true; load(st);
      card.classList.add('is-cycling');
      st.frames[0].classList.add('is-on');
      if (reduce) { (function wait() { if (st.on && !show(st, 1, 0)) st.t = setTimeout(wait, 100); })(); return; }
      ticks(st, 0, FIRST); play(st, FIRST);
    }
    function finish(card) {
      clearTimeout(card.__stkLeave); card.__stkLeave = 0; card.__stkLeft = null;
      card.classList.remove('is-leaving');
      card.querySelectorAll('.stk-card__img').forEach(function (img) { img.classList.remove('is-on', 'is-prev'); });
      card.querySelectorAll('.stk-card__ticks i').forEach(function (t) { t.classList.remove('is-on', 'is-done'); });
    }
    function start(card) {
      if (card.__stkCycle) return;
      var frames = [].slice.call(card.querySelectorAll('.stk-card__img'));
      if (frames.length < 2) return;
      // Back on the card while the photo is still fading out: pick up from that photo instead of jumping to the first.
      var left = card.__stkLeave && card.__stkLeft;
      if (left && !reduce) {
        clearTimeout(card.__stkLeave); card.__stkLeave = 0; card.__stkLeft = null;
        card.classList.remove('is-leaving'); card.classList.add('is-cycling');
        card.__stkCycle = left; left.on = true; left.x0 = null; left.scrub = false;
        ticks(left, left.i, STEP); play(left, STEP);
        return;
      }
      if (card.__stkLeave) finish(card);
      var st = card.__stkCycle = { frames: frames, ticks: [].slice.call(card.querySelectorAll('.stk-card__ticks i')), i: 0, t: 0, on: false, x0: null, scrub: false };
      st.t = setTimeout(function () { begin(card, st); }, INTENT);
    }
    function stop(card) {
      var st = card.__stkCycle;
      if (!st) return;
      clearTimeout(st.t); card.__stkCycle = null;
      if (!st.on) return;
      st.on = false;
      card.classList.remove('is-cycling');
      if (reduce || st.i === 0) { finish(card); return; }
      card.classList.add('is-leaving');
      card.__stkLeft = st;
      card.__stkLeave = setTimeout(function () { finish(card); }, LEAVE);
    }
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('.stk-card');
      if (card && !card.contains(e.relatedTarget)) start(card);
    });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.stk-card');
      if (card && !card.contains(e.relatedTarget)) stop(card);
    });
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('.stk-card'), st = card && card.__stkCycle;
      if (!st || !st.on) return;
      var r = card.querySelector('.stk-card__media').getBoundingClientRect();
      if (e.clientY > r.bottom) return;
      if (!st.scrub) {
        if (st.x0 === null) st.x0 = e.clientX;
        if (Math.abs(e.clientX - st.x0) < 12) return;
        st.scrub = true;
      }
      var pos = (e.clientX - r.left) / r.width * st.frames.length;
      var n = Math.max(0, Math.min(st.frames.length - 1, Math.floor(pos)));
      // Keep the current photo until the mouse is a quarter of a zone past its edge, so a hand resting on a boundary
      // doesn't flick between two photos (the zones are only about 35px wide on a desktop grid).
      if (n === st.i || Math.abs(pos - (st.i + 0.5)) < 0.75) return;
      if (show(st, n, reduce ? 0 : STEP) && !reduce) play(st, STEP);
    }, { passive: true });
  })();

  function init(root) { initReveal(root); initHero(root); initQuickAdd(root); initSlider(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
